import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import styled from "styled-components/macro";

import { useGetCurrentSignupList } from "Utilities/Hooks/useGetCurrentSignupList";

import SignupOption, { SignupSubOption } from "../SignupOption";
import {
  getBeginningOfToday,
  getEndOfToday,
  getNextWeek,
  getNextYear,
  isToday,
} from "../util";

export default function CloseAt() {
  const {
    options: { expireDate: expireTime },
    signupListStatusID,
  } = useGetCurrentSignupList();

  const [expireDate, setExpireDate] = useState(
    expireTime ? new Date(expireTime * 1000) : getNextWeek()
  );

  const hasExpireTime = expireTime > 0;
  const now = new Date();

  return (
    <SignupOption
      text="Automatically close this Signup at a certain time"
      name="expires"
      on={hasExpireTime}
      disabled={signupListStatusID !== 1}
      customValue={expireDate.getTime() / 1000}
      customDispatchName="expireDate"
    >
      <SignupSubOption show={hasExpireTime}>
        <DatePickerWrapper>
          <DatePicker
            selected={expireDate}
            onChange={setExpireDate}
            showTimeSelect
            timeIntervals={15}
            timeCaption="Time"
            dateFormat="MMMM d, yyyy h:mm aa"
            minDate={now}
            minTime={isToday(expireDate) ? now : getBeginningOfToday()}
            maxDate={getNextYear()}
            maxTime={getEndOfToday()}
            popperModifiers={{
              offset: {
                enabled: true,
                offset: "-78px, 0px",
              },
            }}
          />
        </DatePickerWrapper>
      </SignupSubOption>
    </SignupOption>
  );
}

const DatePickerWrapper = styled.div`
  .react-datepicker__input-container input {
    width: 200px;
  }
  .react-datepicker__month-container {
    border-right: 1px solid #aeaeae;
  }
  .react-datepicker__time-container {
    border-left: none;
  }
`;